let API_HOST = '';

if(process.env.NODE_ENV === 'development' || (process.env.REACT_APP_NODE_ENV && process.env.REACT_APP_NODE_ENV === 'local')) {
    API_HOST = 'http://localhost:4714'
}

export default API_HOST;